import dayjs from "dayjs"
import {
  DcCollectionLogFilterInput,
  useAllDcCollectionLogsLazyQuery,
  useAllTransactionsQuery,
} from "generated/graphql"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { useCurrentDcId } from "store/auth.redux"
import { useFilter } from "../../store/search-filter/search-filter.reducer"

export const useAllTransactions = () => {
  const [params] = useSearchParams()
  const dcId = useCurrentDcId()
  const page = parseInt(params.get("page")) || 0
  const search = params.get("search") || ""
  const date = params.get("date") || dayjs().format("YYYY-MM-DD")
  const [filter] = useFilter("fund-flow")
  return useAllTransactionsQuery({
    variables: {
      first: 15,
      skip: page * 15,
      query: search,
      filter: {
        date_Lte: date,
        date_Gte: date,
        paymentMethods: filter?.paymentMethods?.map(p => p.id),
        transactionTypes: ["BANK_DEPOSIT"],
        status: filter?.status?.map(s => s.id),
        dcId,
      },
    },
  })
}

export const useFundFlow = (filterInput: DcCollectionLogFilterInput) => {
  const filterInputJson = JSON.stringify(filterInput)
  const [getRequests, response] = useAllDcCollectionLogsLazyQuery()

  useEffect(() => {
    getRequests({
      variables: {
        filter: { ...JSON.parse(filterInputJson) },
      },
    })
  }, [getRequests, filterInputJson])
  return response
}
